import jsCookie from 'js-cookie'
import { isMiniprogram, isWeixin } from 'kwsdk'
import utils from '@/plugins/utils'
export function getDevice() {
  const ua = navigator.userAgent
  const src = jsCookie.get('source')
  if (src === 'ios') {
    return 'ios'
  } else if (src === 'android') {
    return 'android'
  } else if (/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if (/Mobile/i.test(ua)) {
    return 'mobile'
  } else if (/HZW_SCREEN\/android/i.test(ua)) {
    return 'hzw_screen'
  }
  return 'other'
}

export async function getSelectterm() {
  if (isHZWAPP()) {
    return '孩子王APP'
  } else if (isRKHYAPP()) {
    return '人客合一'
  } else if (await utils.isInLocalKidsMiniprogram()) {
    return '同城亲子小程序'
  } else if (await utils.isMiniProgramAsync()) {
    return '小程序'
  } else if (isWeixin) {
    return 'H5(微信商城)'
  } else {
    return ''
  }
}

export function isAndroid() {
  return getDevice() === 'android'
}

export function isIOS() {
  return getDevice() === 'ios'
}
export function isRKHYAPP() {
  const source = jsCookie.get('source')
  const apptype = jsCookie.get('apptype')
  return (source === 'android' || source === 'ios') && apptype === 'rkhy'
}

export function isMmz() {
  const source = jsCookie.get('source')
  const appcode = jsCookie.get('appcode')
  if (location.href.includes('hzwMmz=1') && isHZWAPP()) return true
  return (source === 'android' || source === 'ios') && appcode === 'MMZ_MALL'
}

export function isHZWAPP() {
  // app特指孩子王app，不包括人客合一
  const source = jsCookie.get('source')
  const appcode = jsCookie.get('appcode')
  return (source === 'android' || source === 'ios') && appcode === 'HZWMALL'
}
export function isSKHYAPP() {
  const source = jsCookie.get('source')
  const apptype = jsCookie.get('apptype') || jsCookie.get('appcode')
  return (source === 'android' || source === 'ios') && apptype === 'hzwygj'
}

// app拉起小程序
export function appLaunchMp(link, mpType) {
  const mpAppId = 'gh_362b01c44275'
  if (isIOS()) {
    let obj = {
      targetClass: 'KTemaiJsConfig',
      methodType: 1,
      methodName: 'openMiniProgramWithUserName_path_miniProgramType_',
      parm: [
        {
          parmClass: 's',
          parmValue: mpAppId
        },
        {
          parmClass: 's',
          parmValue: encodeURIComponent(link)
        },
        {
          parmClass: 's',
          parmValue: mpType || '0' // 小程序版本 0 正式版 1 开发版 2 体验版
        }
      ]
    }
    window.kwapp && window.kwapp.setNativeInfo(obj)
  } else if (isAndroid()) {
    let obj = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: 0,
      methodName: 'openMiniProgramWithUserName',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'userName',
          parmValue: mpAppId
        },
        {
          parmClass: 's',
          parmKey: 'page',
          parmValue: link
        },
        {
          parmClass: 's',
          parmKey: 'miniprogramType',
          parmValue: mpType || '0' // 小程序版本 0 正式版 1 开发版 2 体验版
        }
      ]
    }
    window.localjs.invokeNativeMethod(JSON.stringify(obj))
  }
}

// app复制
export function appCopyText(text) {
  if (isIOS()) {
    let obj = {
      targetClass: 'HZWPasteboardManager',
      methodType: 0,
      methodName: 'copyText_smsg_fmsg_',
      parm: [
        {
          parmClass: 's',
          parmValue: text
        },
        {
          parmClass: 's',
          parmValue:
            '已为您复制好友微信昵称，即将为您跳转微信，可在微信搜索并联系她'
        },
        {
          parmClass: 's',
          parmValue: '复制好友微信昵称失败，请稍后再试'
        }
      ]
    }
    window.kwapp && window.kwapp.setNativeInfo(obj)
  } else if (isAndroid()) {
    let obj = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: 0,
      methodName: 'controlCopyText',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'content',
          parmValue: text
        },
        {
          parmClass: 's',
          parmKey: 'success',
          parmValue:
            version < 110
              ? '已为您复制好友微信昵称，可在微信搜索并联系她'
              : '已为您复制好友微信昵称，即将为您跳转微信，可在微信搜索并联系她'
        },
        {
          parmClass: 's',
          parmKey: 'fail',
          parmValue: '复制好友微信昵称失败，请稍后再试'
        }
      ]
    }
    window.localjs.invokeNativeMethod(JSON.stringify(obj))
  }
}
// app拉起微信好友列表
export function appOpenWx() {
  if (isIOS()) {
    let obj = {
      targetClass: 'KTemaiJsConfig',
      methodType: 1,
      methodName: 'openWxApp'
    }
    window.kwapp && window.kwapp.setNativeInfo(obj)
  } else if (isAndroid()) {
    let obj = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: 0,
      methodName: 'openWeiXin',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'url',
          parmValue: '1'
        }
      ]
    }
    // alert(obj.methodArgsTypes)
    window.localjs.invokeNativeMethod(JSON.stringify(obj))
  }
}

/* 显示首页按钮与分享按钮, 会覆盖默认的分享按钮 */
export function showIndexAndShare(showIndex = true, showSahre = true) {
  const parmValue = []
  if (showIndex) {
    // 首页图标的base64
    const indexIconBase64 =
      'data:image/png;base64,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'
    parmValue.unshift({
      icon: indexIconBase64, // 图标（使用设计稿中44x44的那张）
      title: '', // 文案
      titleColor: '', // 6位数颜色
      link: 'https://life.cekid.com/h5/home', // 跳转页面链接（优先级其次）
      method: '', // 点击回调（优先级最低）
      methodAlways: '' //点击回调（优先级最高）
    })
  }
  if (showSahre) {
    // 分享图标的base64
    const shareIconBase64 =
      'data:image/png;base64,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'
    parmValue.unshift({
      icon: shareIconBase64,
      methodAlways: 'window.kwapp.invokeShareBoard()' // 拉起分享面板
    })
  }
  if (parmValue.length > 0) {
    try {
      if (window.kwapp) {
        if (window.kwapp.configTopButtons) {
          window.kwapp.configTopButtons(parmValue)
        } else if (window.kwapp.onReady) {
          window.kwapp.onReady(() => {
            window.kwapp.configTopButtons(parmValue)
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
}

/* 自定义分享按钮 */
export function configShareButton(shareBefore) {
  const defaultShareBefore = callback => {
    callback()
  }
  shareBefore = shareBefore || defaultShareBefore
  window.shareFunction = () => {
    shareBefore(() => {
      window.localjs.invokeAppShare() //拉起分享面板
    })
  }
  if (isIOS()) {
    const shareIconBase64 =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAALKADAAQAAAABAAAALAAAAAD8buejAAAEDklEQVRYCe2YSWgUQRRAnWQi0bhACIEoKIhm14hRYQ6SiAuKqAgqMgcJCHoQl5OKeBG9qDdB0IMH14N6MQZFRRnxMKKGhJiQRUWEaJDRoBhINJOM74/zm+omksXquDAFNfWr6tf/r3/XMl0TJvxjKfA38JaUlBQMDg7egOVbIpGoy8rKqm1paXk1FNtfAVxYWHgauD0ewNaMjIybtNW2trY+CQQCCekfErioqGgqCod52iryQvQmifIYUyOOV7a1tX361fji4uIqIlxL/7ShdGB51t7evlT6MrwKPO0S2l5g4BCwIeTfgRXzC7GzQoRfJR7mUU5OzlzAdpBvkntNXcYvrqysnC5tLuBUZK+jMNsc8JtyIwAPhrPR0NAQ4008RQ/3iWyP/rv6+vov0hY0OzB8mMgq7Afqu3Jzc+9Fo1HXE5tjbMhEb3JPT89RfO8H1sWUsn9J/bg6Ua7SDoFl3sik9zXxVtcAexbfGijxl8B/L22TpRIMBu9IKck1JVCQBZZMElmV/Sirq6uDwJ7A520TFtCH5E0Ki+/P+fn5UWVwAdPoLDA/p0FFRcXMrq6uCFAH8Kk7VQx5O291BcDzFBD5fiQSiWvdNSW00c+SqC7o6+u7A+wMw08dC65Gtz765mgf8i2VpfRG2OyzLgO7HIDHCkv04uSDRHWDwqacnqI9gnwhHA5fMUH0dSTb2IMT2tnR0eHq0/axlhwO6wG9QZ6YsvGZqG4CNDIam+MyJYCtZsu6BpjCdmZmZq7lyG0eDazo+j4lmAaLiaocu8nDgFf9Mjs7OzQWWN+By8vLS3AiC2yqOCN1Mg1WNTU1df6sjv7XtwiXlZXl9vf3C2yeYBHZjxSriOzbkWJiQ6eQM8QXYCADwF6kTJ5ewH4lr2EhtzmehxGYSmew0SelqeoLMItMDoR1KUdyzIbZDepNxyOQd6IjO5WUTrIOXFpaugzrx9UDsCeBrdP6SEveTnIH01LHWQVmzk0ZGBi4bDh5XFBQcESd2Sit7sPxePwYsLMEjMjKIttm/g+wAWwtwszbSmD3KhTA+zhy32vdVmkNGNiTQCXtAXuXeXvVFqRpxybwIjEM7Hc+03ebTmzK1oABrSFHyZubm5tf24Q0bVlbdKnPKd8/qaxF2IyCn3Ia2M/oiu10hNMR9kQgPSU8AbFe9UbYufQLhULOLZB1r8MY9Ph2mGSYC5hjtVFtdXd3r1Z5vEvTt8kkHF7gRwrHv69zfE9t9DytdvtSii/xKb7VAcAOk7TJN5OTUJbP8RcMMK8+nf7xFoB9i8/5/E/5qr5dEZYO7mK3phRV54+UwkDgtpiwApLppYnFYu/y8vLOc+Eh0Zd+uVfI8ur5VO8F9Dm+5QIwzLXAG5/8pM3+PxH4ARbYiXwDs8+cAAAAAElFTkSuQmCC'
    const options = {
      targetClass: '',
      methodType: '0',
      methodName: 'hzwConfigRightButton_',
      parm: [
        {
          parmClass: 'a',
          parmValue: [
            {
              icon: shareIconBase64,
              method: 'window.shareFunction()'
            }
          ]
        }
      ]
    }
    const str = JSON.stringify(options)
    window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str)
  } else if (isAndroid()) {
    const shareIconBase64 =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAABYCAYAAACeV1sKAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAWaADAAQAAAABAAAAWAAAAABgJoNTAAAE7ElEQVR4Ae2aS2gTQRjHTZtKtT6glEIVFET71harQg7Sig8UURFUJAcpCHoQHyeV4kX0ot4EQQ8efB7Ui7UoKkrEQ0QtLbWlDxURqkWiRbHQatPG/xczYRuibpudcbf8Fybz2Jnv8dtvZ3ayO2UKDxIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIgARIggUlIwDcJfYq7VFZWVjQ6OnoLlR+xWKwpJyensaOj483/8HfSQi4uLj4LoPtToHZmZWXdRltjZ2fnM5/PF0s5r6VqDHJJSclMONWAqKpFqoY30zLwqBWw1nR1dX35k4zS0tJaRHIjzs9K1we2vOju7l6R7pzTbVlOC0wnD1G1HO2v4PRRAA6gnAlgUVENOaul8KcDF+BJXl7eQsDcjXQbadDaF+OX1dTUzLa26Sprh5yI4Jtwar6DTrQC2qN/yWtpaYkg4p+jH9THclP6f2hubv6W0qal6tci1SIUMBoQwQrwJ9T35ufnPwiHw2MiyzLEkSKidPrAwMBx6D4EwOn8vOKIIhtC0im3Mcx+FzhYq3oLYMyDsvBoPXD3rAfg89CtLq7oi0H/INqmS8Xv99+T3MShfbqAU7LIxQ+JYFXWkdfV1fkB+BR03rUCBtzHSFsVYOj+WlhYGNZhQzqZ2iFDaXKR0zlFVFVVze3r6wsB5GHoVE9NEZR34e5ZDciLFACUH4ZCoaiq6861Txe6HRD5iN4lQ0ND9wB4jkVfExa9evWYh3ML1DmU76iyidxEJGv1A4BXAdpTBRhRGkU6gujdrAAnDDiD9hDKl4LB4DWtRqUIV7dVSrNzVTwjx5S0np4eR/Vhw7EJcG8hTU3o+Iro3Qq4IaXTDblnpwsArsPj2Q1AVIB7s7OzN2C73O4GsFYbPDldYIpYhuiVLXN8g4Fp4HVubm7AjYAFtucgV1ZWlsFuWeRmigM4ejFFrG1ra+v9XXXfr6cgV1RU5A8PDwvgAkGJCP6MbC0i+L1dtJChphe7QzLu5xnIAOsD4MvI47s4AP6OtB6LaZddCphmzkHGkOR2xzjRzzOQsdDJJmNjwmnZIgfxFNE8Tgh70F+ecCQ3dngCcnl5+UoQOamoAPBpAG5Sdbs57oL405TK7Y7LtJ/rIWMOnTEyMnLVAuZpUVHRsUwdNzne9c/J0Wj0BADPEyiIYFnodpr838GJi+HqSMY8XAPAB5SjgHwQ2+WPqu6V3NWQAfg0QMZtBOD7mIevewWs1U63Q14qxgLwT7zS32c13EtlV0MG3HqkMNK29vb2t14Ca7XV1Qtf4lWV9tdVViA6yq6OZB0O/w+ZhGyAOiETsgECBlQwkgnZAAEDKhjJhGyAgAEVJiI5+WFhIBBIfk1kwLcxKlJ0J20a00lTRTtkbIlble39/f3rVNl0btVttcmEHSYgP1GO4F+1C3i/tiUlqtRpLbnoEp2iWykA5KRNqk1nLu+7tB5wUF7dv4KT1s9Yter8m3AAfo/zi/G/yPe/9XPynPZIFmfwLfCOhHNO2j5uWWIDLvZ2k4DFyOxxWzqBAZFI5ENBQcFFfIQid47olO8mciYgaiJDBgH3JXTLR4ZBfELwbiJCOIYESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAEJiWBX56/iXwGHdDZAAAAAElFTkSuQmCC'
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'controlRightAction',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'button0',
          parmValue: {
            icon: shareIconBase64,
            method: 'javascript:window.shareFunction();'
          }
        }
      ]
    }
    const str = JSON.stringify(options)
    window.localjs &&
      window.localjs.invokeNativeMethod &&
      window.localjs.invokeNativeMethod(str)
  }
}

/* App下载图片并保存到相册 */
export function saveImagesToAlbum(urls, callback) {
  let handleFailed = false
  if (isIOS()) {
    const options = {
      targetClass: 'KTemaiJsConfig',
      methodType: '1',
      methodName: 'savePicsAndVideosArray_callback_',
      parm: [
        {
          parmClass: 's',
          parmValue: JSON.stringify({
            image: urls
          })
        }
      ]
    }
    console.log('options', options)
    const str = JSON.stringify(options)
    if (window.app && window.app.jsNavtiveHandle) {
      window.downloadCallback = callback
      window.app.jsNavtiveHandle(str, callback && 'downloadCallback')
    } else {
      handleFailed = true
    }
  } else if (isAndroid()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'kwBatchSaveImageWithUrl',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'picUrlList',
          parmValue: JSON.stringify({
            urlList: urls
          })
        }
      ]
    }
    console.log('options', options)
    const str = JSON.stringify(options)
    if (window.localjs && window.localjs.invokeNativeMethod) {
      window.kwBatchSavePicCallBack = callback
      window.localjs.invokeNativeMethod(str)
    } else {
      handleFailed = true
    }
  } else {
    handleFailed = true
  }
  if (handleFailed) {
    setTimeout(() => {
      callback && callback(0)
    }, 700)
  }
}

/* App保存base64到相册 */
export function saveImageToAlbum(base64, callback) {
  let handleFailed = false
  if (isIOS()) {
    base64 = base64.split(',')[1]
    const options = {
      targetClass: 'HZWJSBridgeManager',
      methodType: '0',
      methodName: 'saveImageWithBase64_successMsg_failMsg_',
      parm: [
        {
          parmClass: 's',
          parmValue: base64
        }
      ]
    }
    const str = JSON.stringify(options)
    if (window.app && window.app.jsNavtiveHandle) {
      window.app.jsNavtiveHandle(str)
    } else {
      handleFailed = true
    }
  } else if (isAndroid()) {
    const options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'kwBatchSaveImageWithUrl',
      methodArgsTypes: 't,b',
      parm: [
        {
          parmClass: 's',
          parmKey: 'picUrlList',
          parmValue: JSON.stringify({
            urlList: [base64]
          })
        }
      ]
    }
    const str = JSON.stringify(options)
    if (window.localjs && window.localjs.invokeNativeMethod) {
      window.localjs.invokeNativeMethod(str)
    } else {
      handleFailed = true
    }
  } else {
    handleFailed = true
  }
  base64 = null
  if (handleFailed) {
    setTimeout(() => {
      callback && callback(0)
    }, 700)
  }
}

/* 隐藏app的返回按钮 */
export function setBackBtnHide() {
  let options = null
  if (isIOS()) {
    options = {
      targetClass: 'self',
      methodName: 'setBackVisible_',
      methodType: '0',
      params: [{ parmClass: 's', parmValue: '0' }]
    }
    const str = JSON.stringify(options)
    window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str)
  } else if (isAndroid()) {
    options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodName: 'setBackVisible',
      methodType: '1',
      methodArgsTypes: 't,b',
      parm: []
    }
    const str = JSON.stringify(options)
    window.localjs &&
      window.localjs.invokeNativeMethod &&
      window.localjs.invokeNativeMethod(str)
  }
}

/* 获取刘海屏高度 */
export function getHeaderHeight() {
  let options = null
  let res = null
  if (isIOS()) {
    options = {
      targetClass: 'KTemaiJsConfig',
      methodType: 1,
      methodName: 'getNaviTypeConfig',
      parm: []
    }
    const str = JSON.stringify(options)
    res =
      window.app &&
      window.app.jsNavtiveSyncHandle &&
      window.app.jsNavtiveSyncHandle(str)
  } else if (isAndroid()) {
    options = {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodName: 'getNaviTypeConfig',
      methodType: '0',
      methodArgsTypes: 't,b',
      parm: []
    }
    const str = JSON.stringify(options)
    res =
      window.localjs &&
      window.localjs.invokeNativeSyncMethod &&
      window.localjs.invokeNativeSyncMethod(str)
  }
  return res ? JSON.parse(res) : { navHeight: 0, statusBarHeight: 0 }
}

/* 隐藏app的返回按钮 */
export function goBackNative() {
  let options = null
  if (isIOS()) {
    options = {
      targetClass: 'self',
      methodName: 'goBack',
      methodType: '0',
      parm: []
    }
    const str = JSON.stringify(options)
    window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str)
  } else if (isAndroid()) {
    window.localjs.goBackDefault()
  }
}
